import { Component, OnInit, OnDestroy, Input, NgModule, SimpleChanges, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoggingMessageService } from 'src/app/core/services/logging-message.service';
import { SiteManagementService } from '../../../services/site-management.service';
import { DataResult } from 'src/app/core/models/data-result.model';
import { FormGroup } from '@angular/forms';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { GridDetails } from '../../site-coordinator/models/grid-details.model';
import { GridDetailResult } from '../../site-coordinator/models/grid-result.model';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-menu-access',
  templateUrl: './menu-access.component.html',
  styleUrls: ['./menu-access.component.css']
})

export class MenuAccessComponent implements OnInit, OnDestroy {
  public selectedSubscriptionID:  number;
  public availableSubscriptions: string;
  private loading = false;
  @Input() selectedUserId: number;  
  @Input() selectedUserRole: number;  
  @Input() mainMenuForceCheckedIndicators: string[];
  @Input() mainMenuForceUncheckedIndicators: string[];
  @Input() isPowerUser: boolean;
  @Input() editUserForm: FormGroup;
  @Output() mainMenuSaveSuccess: EventEmitter<string> = new EventEmitter<string>();

  private $subscriptions: Subscription = new Subscription();
  public menuData = [];
  public kendoStore;
  public gridData: GridDetails[] = [];
  public gridDetailResult: GridDetailResult;
  public state: State = {
    skip: 0,
    take: 10,
    filter: { // Add an initial filter object to the state
      logic: 'and',
      filters: []
    }
  };  

  message: {
    text: string;
    class: string;
  } = {
    text: '',
    class: ''
  };

  public isDataLoading() {
    return this.loading;
  }

  constructor(private dataService: SiteManagementService, 
    private logger: LoggingMessageService, 
    private changeDetectorRef: ChangeDetectorRef,
    private authService: AuthService) {      
    }

  ngOnInit() {
    this.selectedSubscriptionID = this.authService.SelectedSubscription;
    this.availableSubscriptions = this.authService.AvailableSubscriptionsString;
    //no need to call on init. but only when user is selected.
    //this.subscribeToMenuData(this.selectedUserId);
  }

  //To regenerate the grid in the MenuAccessComponent when the user changes, you can listen to changes in the selectedUserId input using the ngOnChanges lifecycle hook
  //ngOnChanges checks if the selectedUserId input has changed. If so, it calls the subscribeToMenuData method to fetch the menu data for the new user
  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedUserId && !changes.selectedUserId.firstChange) {
      const newUserId = changes.selectedUserId.currentValue;
      // Reset grid to the first page upon user change.
      this.state = {
        ...this.state,
        skip: 0, // Reset skip count to start from the first page
        take: this.state.take || 10 // Preserve the current page size or default to 10
      };      
      //empty the grid if no user is selected (userid = 0 or null)
      if (newUserId) {
        this.subscribeToMenuData(newUserId);
      } else {
        this.emptyDataGrid();
      }
    }
  }

  private emptyDataGrid() {
    this.menuData = []; //  menuData is the variable holding your grid data
    this.kendoStore = []; // Update Kendo Grid's data store if separate
    this.setKendoData(); // Update the grid view
  }

  //this is being used upon cancel to refresh the grid by calling the subscribeToMenuData.
  public refreshMenuData(selectedUserId: number) {
    this.subscribeToMenuData(selectedUserId);
  }
  
  private subscribeToMenuData(selectedUserId: number) {
    this.loading = true;
    const menuData$ = this.dataService.getMainMenuAccess(this.selectedUserId)
      .subscribe((md: any) => {
        const menuResult = md as DataResult;
        if (menuResult.Ok === true) {
          this.menuData = menuResult.Data;
          this.kendoStore = this.menuData;
          this.setKendoData();
        } else {
          this.logger.warn('app-menu-access', 'subscribeToMenuData',  this.selectedSubscriptionID , this.availableSubscriptions,`Result:${menuResult.Status}, Status:${menuResult.StatusText}`, '');
        }
        this.loading = false;
      },
      error => {
         this.logger.error('app-menu-access', 'subscribeToMenuData', this.selectedSubscriptionID , this.availableSubscriptions, 'caught error', error);
        this.loading = false;
      });
    this.$subscriptions.add(menuData$);
  }
 
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.menuData, this.state).data; // Update gridData with the processed data
    this.postWindowMessage();
  }
    
  private postWindowMessage() {
    setTimeout(() => {
      this.logger.info('menu-access.component', 'postWindowMessage', this.selectedSubscriptionID , this.availableSubscriptions, `sysId=${this.selectedUserId}`, '');
      window.parent.postMessage('indicatorfactoryaction:', '*');
    }, 0);
  }

  public setKendoData() {
    this.gridData = process(this.menuData, this.state).data;
  }

  //disable based on mandatoryInds and notAllowed for each Indicator.
  isMenuPermissionDisable(dataItem): boolean{ 
    const mandatoryInds = this.mainMenuForceCheckedIndicators; 
    const notAllowedIns = this.mainMenuForceUncheckedIndicators;
    return (notAllowedIns.includes(dataItem.indicatorID) || mandatoryInds.includes(dataItem.indicatorID));    
  }

  //checked based on mandatoryInds.
  isMenuPermissionChekced(dataItem): boolean{
    const mandatoryInds = this.mainMenuForceCheckedIndicators; 
    return mandatoryInds.includes(dataItem.indicatorID) || dataItem.authorized;
  }

  onCheckboxChange(dataItem: GridDetails): void {
    // upon chkbs click, If authorized was true, it will become false; and if it was false, it will become true. 
      dataItem.authorized = !dataItem.authorized; 
      this.postWindowMessage();
  }
  
   // visible  if tutPassed = true and tutExisits = true
   hidetutDate( tutExisits: boolean, tutPassed: boolean): boolean{
    const visible = tutExisits && tutPassed
    return !visible;
  }

  formatDate(dateString: string): string {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString(); // Customize the date format as needed
    }
    return '';
  }

  private Unsubscribe() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribe();
  }

}

